/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

interface IAccountAddressTileDescription {
    description: string;
}

const IAccountAddressTileDescription: React.FC<IAccountAddressTileDescription> = ({ description }) => (
    <p className='ms-account-address-tile__description'>{description}</p>
);

export default IAccountAddressTileDescription;
